"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ROUTES = void 0;
const ROUTES = exports.ROUTES = {
  DmsAlertPage: '/dms-alert',
  DmsActiveAlertPage: '/dms-alert/active-alerts'
};